import React from "react";
import { getUserRoleName, logout } from "../pages/azureLogin/authUtility";
import { useHistory } from "react-router-dom";

const NkHeader = ({ title }) => {
  const history = useHistory();
  const mainHeaderWrapper = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#fff",
    fontFamily: "Montserrat-Medium",
    fontWeight: "bold",
    paddingBottom: "20px",
  };
  const logoutArea = {
    color: "#fff ",
    fontFamily: "Montserrat-Medium",
  };
  const titleArea = {
    color: "#fff !important",
    fontFamily: "Montserrat-Medium",
  };
  const titleCss = {
    color: "#fff !important",
    fontSize: "1.625rem",
    fontFamily: "Montserrat-Medium",
  };

  const roleName = getUserRoleName();

  const onLogout = async () => {
    try {
      const logoutResponse = await logout();
      if (logoutResponse) {
        history.push("/login");
      }
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <div style={mainHeaderWrapper}>
      <div style={titleArea}>
        <div style={titleCss}>{title}</div>
      </div>

      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          style={{
            textAlign: "center",
            // color: ,
            marginTop: "-5px",
            fontSize: "16px",
            paddingRight: "12px",
            fontFamily: "Montserrat-Regular",
          }}
        >
          <large>{localStorage.getItem("username")}</large>
          <div>
            <small>{roleName}</small>
          </div>
        </div>

        <div style={logoutArea}>
          <button
            className="btn btn-light"
            onClick={onLogout}
            style={{ background: "none" }}
          >
            <i
              style={{ marginRight: 10 }}
              className="fa fa-power-off"
              aria-hidden="true"
            ></i>
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default NkHeader;
